/**
 * LumirEditor 커스텀 에러 (P8-①) — kingdoo-editor errors/LumirEditorError.ts 이식.
 * 코드 + 한국어 사용자 메시지(getUserMessage) + 팩토리.
 */

export const LUMIR_ERROR_CODES = [
  'UPLOAD_FAILED',
  'INVALID_FILE_TYPE',
  'S3_CONFIG_ERROR',
  'PRESIGNED_URL_ERROR',
  'NETWORK_ERROR',
  'EDITOR_ERROR',
  'UNKNOWN_ERROR',
];

export class LumirEditorError extends Error {
  constructor(message, details) {
    super(message);
    details = details || {};
    this.name = 'LumirEditorError';
    this.code = details.code || 'UNKNOWN_ERROR';
    this.originalError = details.originalError;
    this.context = details.context;
    Object.setPrototypeOf(this, LumirEditorError.prototype);
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      context: this.context,
      stack: this.stack,
    };
  }

  /** 사용자 친화적(한국어) 메시지 */
  getUserMessage() {
    switch (this.code) {
      case 'UPLOAD_FAILED':
        return '파일 업로드에 실패했습니다. 다시 시도해주세요.';
      case 'INVALID_FILE_TYPE':
        return '지원하지 않는 파일 형식입니다. 이미지 파일만 업로드 가능합니다.';
      case 'S3_CONFIG_ERROR':
        return 'S3 설정이 올바르지 않습니다. 관리자에게 문의하세요.';
      case 'PRESIGNED_URL_ERROR':
        return '업로드 URL 생성에 실패했습니다. 다시 시도해주세요.';
      case 'NETWORK_ERROR':
        return '네트워크 연결을 확인해주세요.';
      case 'EDITOR_ERROR':
        return '에디터 오류가 발생했습니다. 페이지를 새로고침해주세요.';
      default:
        return '알 수 없는 오류가 발생했습니다.';
    }
  }

  static fromError(error, code, context) {
    return new LumirEditorError(
      error && error.message ? error.message : String(error),
      {
        code: code || 'UNKNOWN_ERROR',
        originalError: error instanceof Error ? error : undefined,
        context,
      },
    );
  }
  static uploadFailed(message, originalError) {
    return new LumirEditorError(message, {
      code: 'UPLOAD_FAILED',
      originalError,
    });
  }
  static invalidFileType(fileName, allowVideoUpload) {
    const message =
      allowVideoUpload === true
        ? `Invalid file type: ${fileName}. Only image and video files are allowed.`
        : `Invalid file type: ${fileName}. Only image files are allowed.`;
    return new LumirEditorError(message, {
      code: 'INVALID_FILE_TYPE',
      context: { fileName },
    });
  }
  static s3ConfigError(message) {
    return new LumirEditorError(message, { code: 'S3_CONFIG_ERROR' });
  }
  static networkError(originalError) {
    return new LumirEditorError('Network request failed', {
      code: 'NETWORK_ERROR',
      originalError,
    });
  }
}
